/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2017/7/19 上午11:56
 */

import Pagination from './Pagination';

export default Pagination;



// WEBPACK FOOTER //
// ./src/pagination/index.js